<template>
  <div class="tool">
    <div class="tool__pannel__top">
      <div class="main-width">
        <h3 class="tool__title">分销工具帮您步步为赢</h3>
        <p class="tool__sub">全方位满足您的经营需求，突破销量瓶颈</p>
        <div class="tool__btn" @click="toResourcePage">
          立即体验
          <i class="ficon ficon-right" />
        </div>
      </div>
    </div>
    <div class="tool__pannel__bottom">
      <div class="main-width">
        <div class="nav__wrapper">
          <div class="nav">
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-gexingdianpu" />
              </div>
              <h5 class="nav__item__title">店铺装修</h5>
              <p
                class="nav__item__desc"
                v-html="'一键开店，多种装修组件<br/>快速搭建直销平台'"
              ></p>
            </div>
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-erweimagongju" />
              </div>
              <h5 class="nav__item__title">二维码</h5>
              <p
                class="nav__item__desc"
                v-html="'搭建专属二维码管理系<br/>与自身业务有机结合'"
              ></p>
            </div>
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-huiyuan" />
              </div>
              <h5 class="nav__item__title">会员营销</h5>
              <p
                class="nav__item__desc"
                v-html="'会员体系精细化运营<br/>精准触达，提升复购率'"
              ></p>
            </div>
          </div>
          <div class="nav nav--black">
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-shequfenxiao" />
              </div>
              <h5 class="nav__item__title">社群分销</h5>
              <p
                class="nav__item__desc"
                v-html="'构建完整分销体系<br/>员工、代理、客户一起卖'"
              ></p>
            </div>
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-yingxiaogongju" />
              </div>
              <h5 class="nav__item__title">营销工具</h5>
              <p
                class="nav__item__desc"
                v-html="'优惠套餐，满减、拼团、砍价等<br/>多种玩法帮你提升业绩'"
              ></p>
            </div>
            <div class="nav__item">
              <div class="nav__item__icon">
                <i class="ficon ficon-gengduogongneng" />
              </div>
              <h5 class="nav__item__title">更多功能</h5>
              <p
                class="nav__item__desc"
                v-html="'营销服务持续完善中<br/>敬请期待'"
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { moveToScrollTop } from "@/utils/getScrollTop";
export default {
  data() {
    return {};
  },
  computed: {
    auth() {
      return this.$store.state.auth;
    },
    isDistributor() {
      if (!this.auth.loggedIn) return false;
      return !!this.auth.user.distributor;
    },
  },
  methods: {
    toResourcePage() {
      if (!this.isDistributor) {
        // scrollto login section
        moveToScrollTop(0);
      } else {
        this.$router.push("/resource");
      }
    },
  },
};
</script>
<style lang="scss" scoped>

.tool {
  position: relative;
  color: #fff;
  &__pannel__top {
    min-height: 700px;
    background: url("~/assets/img/home/tool_bg1.png") no-repeat top;
    background-size: 3000px 700px;
    text-align: center;
  }
  &__title {
    padding-top: 44px;
    line-height: 56px;
    font-size: 40px;
    font-weight: 600;
    padding-bottom: 10px;
    text-align: center;
  }
  &__sub {
    font-size: 22px;
    text-align: center;
    margin-bottom: 28px;
  }
  &__btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 175px;
    height: 55px;
    border: 1px solid #ffffff;
    border-radius: 8px;
    font-size: 20px;
    user-select: none;
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s all ease;
    .ficon {
      margin-left: 5px;
      position: relative;
      left: 0;
    }
    &:hover {
      background-color: rgba(#ffffff, 0.9);
      color: #a561c3;
      .ficon {
        animation: finger infinite 2s;
      }
    }
  }
}
.nav {
  display: flex;
  color: #fff;
  &__wrapper {
    width: 50%;
    margin-left: 50%;
    margin-top: -430px;
    padding-left: 10px;
  }
  &__item {
    width: 185px;
    text-align: center;
    &__icon {
      display: inline-block;
      width: 35px;
      height: 35px;
      margin-bottom: 10px;
    }
    &__title {
      font-size: 22px;
      margin-bottom: 10px;
      font-weight: 500;
    }
    &__desc {
      font-size: 13px;
      white-space: nowrap;
    }
    .ficon {
      font-size: 26px;
    }
  }
  &--black {
    color: #495057;
    padding-top: 75px;
    .nav__item__desc {
      color: #adb5bd;
    }
  }
}
@keyframes finger {
  0% {
    transform: translate(0);
  }

  25% {
    transform: translate(10px);
  }

  50% {
    transform: translate(0);
  }

  75% {
    transform: translate(10px);
  }

  100% {
    transform: translate(0);
  }
}

</style>
